import {
	AlphaFourDCss,
	AlphaOneDCss,
	CSS,
	CssBackgroundImageGradient,
	CssBorder,
	cssString,
	CssTypography,
	CssTextColor,
	CssBackground,
	CssFillColor,
} from './Css.jsx';

function CompiledCss( CssObj ) {
	let initialCss = '';
	let lgCss = '';
	let mdCss = '';
	let smCss = '';

	for ( const selector of Object.keys( CssObj ) ) {
		initialCss +=
			selector +
			'{' +
			cssString(
				CssObj?.[ selector ]?.map( ( item ) => item?.initial )
			) +
			'}';

		let lgValue = cssString(
			CssObj?.[ selector ]?.map( ( item ) => item?.lg )
		);
		if ( lgValue ) {
			lgCss += selector + '{' + lgValue + '}';
		}
		let mdValue = cssString(
			CssObj?.[ selector ]?.map( ( item ) => item?.md )
		);
		if ( mdValue ) {
			mdCss += selector + '{' + mdValue + '}';
		}
		let smValue = cssString(
			CssObj?.[ selector ]?.map( ( item ) => item?.sm )
		);
		if ( smValue ) {
			smCss += selector + '{' + smValue + '}';
		}
	}
	let _lgCss = lgCss ? `@media (min-width: 783px){${ lgCss }}` : '';
	let _mdCss = mdCss
		? `@media (min-width: 601px) and (max-width: 782px ) {${ mdCss }}`
		: '';
	let _smCss = smCss ? `@media (max-width: 600px){${ smCss }}` : '';

	let _compliedCss = `${ initialCss } ${ _lgCss } ${ _mdCss } ${ _smCss }`;

	return _compliedCss;
}

function GenerateCss() {
	return <div>GenerateCss</div>;
}

GenerateCss.CompiledCss = CompiledCss;

GenerateCss.borderRadius = ( attributeValue ) => {
	return AlphaFourDCss(
		{ [ 'containerBorderRadius' ]: attributeValue },
		'containerBorderRadius',
		'border-radius',
		[
			'border-top-left-radius',
			'border-top-right-radius',
			'border-bottom-right-radius',
			'border-bottom-left-radius',
		]
	);
};

GenerateCss.margin = ( attributeValue ) => {
	return AlphaFourDCss(
		{ [ 'containerMargin' ]: attributeValue },
		'containerMargin',
		'margin',
		[ 'margin-top', 'margin-right', 'margin-bottom', 'margin-left' ]
	);
};

GenerateCss.padding = ( attributeValue ) => {
	return AlphaFourDCss(
		{ [ 'containerPadding' ]: attributeValue },
		'containerPadding',
		'padding',
		[ 'padding-top', 'padding-right', 'padding-bottom', 'padding-left' ]
	);
};
GenerateCss.lengthProp = ( property, value ) =>
	AlphaOneDCss( { [ 'len' ]: value }, 'len', property );
GenerateCss.border = ( border ) => CssBorder( border );
GenerateCss.css = ( property, value ) => CSS( property, value );
GenerateCss.typography = ( typographyAttribute ) =>
	CssTypography( typographyAttribute );
GenerateCss.textColor = ( textColorAttribute ) =>
	CssTextColor( textColorAttribute );
GenerateCss.fillColor = ( fillColorAttribute ) =>
	CssFillColor( fillColorAttribute );

GenerateCss.backgroundColor = ( colorGradientAttribute ) =>
	CssBackground( colorGradientAttribute );
GenerateCss.background = ( bg ) => CssBackgroundImageGradient( bg );

GenerateCss.backgroundColorGradientImage = ( bg ) =>
	CssBackgroundImageGradient( bg );

GenerateCss.boxShadow = ( imageBoxShadow ) => {
	if ( ! imageBoxShadow ) {
		return;
	}
	const getVal = ( val ) => {
		if ( val === undefined || val === null || val === '' ) return '0px';
		if ( String( val ).match( /px|%|em|rem|vh|vw$/ ) ) return val;
		return `${ val }px`;
	};
	const boxShadowString = [
		imageBoxShadow.inset ? 'inset' : '',
		getVal( imageBoxShadow.x ),
		getVal( imageBoxShadow.y ),
		getVal( imageBoxShadow.blur ),
		getVal( imageBoxShadow.spread ),
		imageBoxShadow.color || 'rgba(0,0,0,0)',
	]
		.filter( Boolean )
		.join( ' ' );
	if ( boxShadowString ) {
		return CSS( 'box-shadow', boxShadowString );
	}
};

export default GenerateCss;
